import { render } from "./App.vue?vue&type=template&id=3d47b5c2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3d47b5c2&lang=scss"
script.render = render

export default script